import { View } from 'react-native'

import { Bullet } from '../bullet'
import { useBadge, type TBadgeProps } from './useBadge'

export const Badge = ({ ref, ...props }: TBadgeProps) => {
  const { children, getBaseProps, getBulletProps } = useBadge(props)

  return (
    <View {...getBaseProps()}>
      {children}
      <Bullet ref={ref} {...getBulletProps()} />
    </View>
  )
}

Badge.displayName = 'Badge'
